import React from 'react';

const LinkedInIcon = () => {
  return (
    <svg width="48" height="49" viewBox="0 0 48 49" fill="none">
      <path
        d="M24.4999 7.40283C34.4416 7.40283 42.5 15.4623 42.5 25.4029C42.5 35.3435 34.4416 43.4028 24.4999 43.4028C14.5583 43.4028 6.5 35.3433 6.5 25.4029C6.5 15.4624 14.5584 7.40283 24.4999 7.40283Z"
        stroke="#F2F2F2"
      />
      <path
        d="M16.4248 32.3218H19.889V20.7754H16.4248V32.3218ZM29.9206 20.3755C28.2394 20.3755 26.7351 20.9894 25.668 22.3446V20.7375H22.1911V32.3219H25.668V26.0573C25.668 24.7334 26.8809 23.4419 28.4002 23.4419C29.9195 23.4419 30.2941 24.7334 30.2941 26.025V32.3208H33.7583V25.7671C33.7582 21.2149 31.603 20.3755 29.9206 20.3755ZM18.1407 19.6216C19.0981 19.6216 19.8751 18.8445 19.8751 17.8871C19.8751 16.9297 19.0981 16.1528 18.1407 16.1528C17.1833 16.1528 16.4062 16.9299 16.4062 17.8873C16.4062 18.8447 17.1833 19.6216 18.1407 19.6216Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};

export default LinkedInIcon;
